import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a184b87c"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxHeaderPortfolio: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/HeaderPortfolio.vue').default,IxDataTableTaxonomy: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Taxonomy.vue').default,IxDataTableSections: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Sections.vue').default,IxDataTableCategories: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Categories.vue').default,IxKpiEdit: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/kpiEdit.vue').default,IxDataTableMetrics: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/Metrics.vue').default,IxDataTableAuditLogs: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/AuditLogs.vue').default,MetricsCellsMetricName: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/cells/MetricName.vue').default,IxChipReportingPeriodType: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/chip/ReportingPeriodType.vue').default,IxButtonWhite: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/White.vue').default})
